module.exports = {"title":"기간별 가동률","region":"지역","selectRegion":"지역을 선택하세요.","enterKeyword":"검색어를 입력하세요.","month1":"1개월","month3":"3개월","aplStatus":"{location} APL 상태 현황","date":"날짜","normal":"정상","abnormal":"비정상","normalUtilRate":"정상 가동률","utilRate":"가동률","noData":"데이터가 없습니다.","maxPeriodAlert":"최대 선택가능한 기간은 90일 입니다.","regionAll":"전국","regionGyeonggiIncheon":"경기도/인천","regionChungbuk":"충청북도","regionChungnam":"충청남도","regionJeolla":"전라도","regionGyeongbuk":"경상북도","regionGyeongnam":"경상남도","regionGangwon":"강원도","regionJeju":"제주도"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/st002.json
// module id = aP9Y
// module chunks = 2